export function TorontoEnforcement() {
  const violations = [
    {
      violation: 'Operating without registration',
      fine: 'Starting at $1,000',
      severity: 'high',
    },
    {
      violation: 'False registration information',
      fine: 'Up to $50,000',
      severity: 'high',
    },
    {
      violation: 'Exceeding 180-night limit',
      fine: 'Up to $10,000',
      severity: 'medium',
    },
    {
      violation: 'Not displaying registration number',
      fine: 'Up to $1,000',
      severity: 'low',
    },
    {
      violation: 'Failing to collect/remit MAT',
      fine: 'Fines for incorrect reporting',
      severity: 'high',
    },
    {
      violation: 'Operating in non‑principal residence',
      fine: 'Up to $50,000',
      severity: 'high',
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left column – description */}
          <div>
            <span className="inline-block bg-[#882629] bg-opacity-10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
              2026 Enforcement
            </span>

            <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
              Platform-Integrated Enforcement
            </h2>

            <p className="text-lg text-[#505A5A]/70 leading-relaxed mb-8">
              Toronto uses an API that syncs daily with Airbnb and other platforms. If your registration expires or is revoked, your listing is automatically hidden within 24 hours. Fines start at $1,000 for non‑compliance.
            </p>

            <div className="bg-[#F8F8F8] rounded-2xl p-6 mb-6">
              <h4 className="font-semibold text-[#505A5A] mb-4 flex items-center gap-2">
                <i className="ri-shield-check-line text-xl text-[#882629]"></i>
                Enforcement Style: Platform Integration
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3 text-[#505A5A]/70">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  Daily API sync with Airbnb - automatic listing removal within 24 hours
                </li>
                <li className="flex items-start gap-3 text-[#505A5A]/70">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  Platform-integrated enforcement for expired or revoked registrations
                </li>
                <li className="flex items-start gap-3 text-[#505A5A]/70">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  Automatic removal for non-compliance
                </li>
                <li className="flex items-start gap-3 text-[#505A5A]/70">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  Fines for incorrect MAT reporting
                </li>
                <li className="flex items-start gap-3 text-[#505A5A]/70">
                  <i className="ri-checkbox-circle-fill text-[#882629] mt-1"></i>
                  Regular audits of registration and MAT tax compliance
                </li>
              </ul>
            </div>

            <div className="bg-amber-50 border border-amber-200 rounded-xl p-5">
              <div className="flex items-start gap-3">
                <i className="ri-alert-line text-xl text-amber-600 mt-0.5"></i>
                <div>
                  <h4 className="font-semibold text-amber-900 mb-1">Automatic Listing Removal</h4>
                  <p className="text-sm text-amber-800">
                    Toronto's platform integration means your listing will be automatically hidden if your registration expires or is revoked. Keep your registration current to avoid disruption.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right column – violation list */}
          <div>
            <h3 className="text-2xl font-semibold text-[#505A5A] mb-6">
              Violation Penalties
            </h3>
            <div className="space-y-4">
              {violations.map((item, index) => (
                <div
                  key={index}
                  className={`rounded-xl p-5 flex items-center justify-between ${
                    item.severity === 'high'
                      ? 'bg-red-50 border border-red-100'
                      : item.severity === 'medium'
                      ? 'bg-amber-50 border border-amber-100'
                      : 'bg-[#F8F8F8] border border-gray-100'
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <i
                      className={`ri-error-warning-fill text-xl ${
                        item.severity === 'high'
                          ? 'text-red-500'
                          : item.severity === 'medium'
                          ? 'text-amber-500'
                          : 'text-gray-400'
                      }`}
                    ></i>
                    <span className="text-[#505A5A] font-medium">{item.violation}</span>
                  </div>
                  <span
                    className={`font-semibold ${
                      item.severity === 'high'
                        ? 'text-red-600'
                        : item.severity === 'medium'
                        ? 'text-amber-600'
                        : 'text-[#505A5A]'
                    }`}
                  >
                    {item.fine}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
